import script from "./KAM002-v1.vue?vue&type=script&setup=true&lang=ts"
export * from "./KAM002-v1.vue?vue&type=script&setup=true&lang=ts"

import "./KAM002-v1.vue?vue&type=style&index=0&id=dad31264&scoped=true&lang=css"

import exportComponent from "/var/build/production/construction-site-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dad31264"]])

export default __exports__